module.exports = __webpack_public_path__ + "img/Picture8.6ad8de3c.jpg";